import React, { FunctionComponent, useMemo } from "react";

import { bridge } from "@multiweb/reactCore/bridge";
import { bemClassNames, TAB_INDEX_FOCUSABLE_TAB_SEQUENCE } from "@multiweb/reactUtils";
import { Role } from "@multiweb/uiShared/Role";
import { CaptionComponent } from "../CaptionComponent";
import { CaptionAlignment } from "../CheckBoxComponent";
import { FlexDirection, Layout, SpacingSize } from "../Layout";
import { FakeComponentProps } from "../types";

const { generateElementID } = bridge;

export type CheckBoxFakeComponentProps = {
    /** Příznak, zda je pole povinné */
    required?: boolean;
    /** Umístění popisu */
    alignment?: CaptionAlignment;
} & Omit<FakeComponentProps, "ariaLabelledBy">;

const classNames = bemClassNames("check-box-fake-component");

export const CheckBoxFakeComponent: FunctionComponent<CheckBoxFakeComponentProps> = ({
    label,
    alignment = CaptionAlignment.rightJustify,
    required,
    title,
    disabled,
    onClick,
    onKeyDown,
    valueTitle,
    isEditing,
    postponedRequired,
    recommended,
}) => {
    const isLeftAligned = alignment === CaptionAlignment.leftJustify;
    const labelId = useMemo(() => `${generateElementID()}-label`, []);
    const isDisabled = disabled || !isEditing;
    const isRequired = required && !isDisabled;
    const isPostponedRequired = postponedRequired && !required && !isDisabled;
    const isRecommended = recommended && !postponedRequired && !isRequired && !isDisabled;
    return (
        <div className={classNames()} {...{ onClick, onKeyDown }} >
            <Layout flexDirection={isLeftAligned ? FlexDirection.rowReverse : FlexDirection.row} >
                <div
                    className={classNames("question-mark-box", { disabled: isDisabled, required: isRequired, postponedRequired: isPostponedRequired, recommended: isRecommended })}
                    title={valueTitle}
                    tabIndex={TAB_INDEX_FOCUSABLE_TAB_SEQUENCE}
                    role={Role.checkBox}
                    aria-checked="mixed"
                    aria-disabled={disabled}
                    aria-labelledby={labelId}
                />
                <Layout
                    spacingSizeLeft={isLeftAligned ? undefined : SpacingSize.xxs}
                    spacingSizeRight={isLeftAligned ? SpacingSize.xxs : undefined}
                >
                    <CaptionComponent
                        id={labelId}
                        text={label}
                        {...{ required, title }}
                    />
                </Layout>
            </Layout>
        </div>
    );
};
